import React, { useEffect, useState, createElement } from 'react';
import { Flame, CheckCircle2, XCircle, ShieldCheck, Download, Lock, Clock, Sparkles, MessageSquare, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouDownsalePage() {
  // 15-minute countdown
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'ThankYou-Downsale-View');
    // Countdown
    const interval = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (s: number) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };
  return <div className="min-h-screen bg-[#0a0e1a] text-white font-sans selection:bg-amber-400 selection:text-black" data-id="element-3104">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3105">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3106" />
      </noscript>

      {/* Urgency Top Bar */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-black py-2.5 px-4 shadow-lg" data-id="element-3107">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 md:gap-3 text-center" data-id="element-3108">
          <Flame className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 animate-pulse" data-id="element-3109" />
          <p className="text-xs md:text-sm font-black uppercase tracking-wide" data-id="element-3110">
            ÚLTIMA OPORTUNIDAD — EXPIRA EN{' '}
            <span className="font-mono bg-black text-amber-400 px-2 py-0.5 rounded ml-1" data-id="element-3111">
              {formatTime(timeLeft)}
            </span>
          </p>
        </div>
      </div>

      {/* Registration Incomplete Alert — keeps visitors on page */}
      <div className="bg-red-600 py-2 px-4" data-id="element-3112">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-center" data-id="element-3113">
          <AlertTriangle className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-300 flex-shrink-0 animate-pulse" data-id="element-3114" />
          <p className="text-white font-bold text-xs md:text-sm uppercase tracking-tight leading-tight" data-id="element-3115">
            Tu registración al webinar no está completa aún
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-3116">
        {/* Hero Section */}
        <section className="text-center mb-10 md:mb-16" data-id="element-3117">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5" data-id="element-3118">
            <Sparkles className="w-3.5 h-3.5 text-amber-400" data-id="element-3119" />
            <span className="text-amber-400 text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-3120">
              Una sola oferta más antes de irte
            </span>
          </div>

          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black leading-[1.15] tracking-tight mb-5 md:mb-6" data-id="element-3121">
            Espera —{' '}
            <span className="text-amber-400" data-id="element-3122">
              Antes de Irte, Tengo Algo Más
            </span>
          </h1>

          <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-3123">
            Entiendo que <span className="text-white font-bold" data-id="element-3124">$27</span>{' '}
            quizás no era el momento. Pero no quiero que llegues al webinar{' '}
            <span className="text-white font-bold" data-id="element-3125">
              sin los mensajes esenciales.
            </span>
          </p>
        </section>

        {/* LITE Version Section */}
        <section className="mb-10 md:mb-14" data-id="element-3126">
          <div className="bg-gradient-to-br from-amber-950/40 to-[#0a0e1a] border border-amber-500/30 rounded-2xl p-6 md:p-10" data-id="element-3127">
            <div className="flex items-start gap-3 mb-6" data-id="element-3128">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-amber-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-3129">
                <span className="text-2xl" data-id="element-3130">📦</span>
              </div>
              <h2 className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-3131">
                Te Tengo La <span className="text-amber-400" data-id="element-3132">Versión LITE</span>{' '}
                del Manual
              </h2>
            </div>

            {/* What's included */}
            <div className="pl-0 md:pl-[60px]" data-id="element-3133">
              <p className="text-white font-bold text-base md:text-lg mb-4" data-id="element-3134">
                ✅ Lo que SÍ incluye:
              </p>
              <ul className="space-y-3 text-gray-300 text-base md:text-lg mb-8" data-id="element-3135">
                <li className="flex items-start gap-3" data-id="element-3136">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-3137" />
                  <span data-id="element-3138">
                    <span className="text-white font-bold" data-id="element-3139">100 mensajes</span>{' '}
                    (los esenciales — los más probados)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3140">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-3141" />
                  <span data-id="element-3142">
                    Cubre los{' '}
                    <span className="text-white font-bold" data-id="element-3143">
                      6 nichos principales
                    </span>
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3144">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-3145" />
                  <span data-id="element-3146">
                    Incluye las{' '}
                    <span className="text-white font-bold" data-id="element-3147">
                      5 Reglas de Oro del WhatsApp
                    </span>
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3148">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-3149" />
                  <span data-id="element-3150">
                    <span className="text-white font-bold" data-id="element-3151">
                      Misma garantía de 7 días
                    </span>
                  </span>
                </li>
              </ul>

              <p className="text-white font-bold text-base md:text-lg mb-4" data-id="element-3152">
                ❌ Lo que NO incluye:
              </p>
              <ul className="space-y-3 text-gray-400 text-base md:text-lg mb-6" data-id="element-3153">
                <li className="flex items-start gap-3" data-id="element-3154">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-3155" />
                  <span data-id="element-3156">Los otros 100 mensajes de situaciones avanzadas</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3157">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-3158" />
                  <span data-id="element-3159">La plantilla editable en Google Docs</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3160">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-3161" />
                  <span data-id="element-3162">Acceso a futuras actualizaciones</span>
                </li>
              </ul>

              <p className="text-gray-300 text-base md:text-lg leading-relaxed border-l-2 border-amber-400 pl-4 italic" data-id="element-3163">
                Pero tienes lo{' '}
                <span className="text-white font-bold not-italic" data-id="element-3164">
                  SUFICIENTE para arrancar el jueves
                </span>{' '}
                después del webinar y cerrar tus primeros clientes.
              </p>
            </div>
          </div>
        </section>

        {/* CTA + Pricing */}
        <section className="mb-8" data-id="element-3165">
          <div className="bg-gradient-to-br from-[#0f1729] to-[#0a0e1a] border-2 border-amber-500/40 rounded-2xl p-6 md:p-10 shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-3166">
            {/* Price summary */}
            <div className="text-center mb-7" data-id="element-3167">
              <p className="text-gray-400 text-sm md:text-base mb-1" data-id="element-3168">
                💰 Inversión única
              </p>
              <p className="text-5xl md:text-7xl font-black text-white mb-2" data-id="element-3169">
                $17{' '}
                <span className="text-lg md:text-2xl text-gray-500 font-medium align-top" data-id="element-3170">
                  USD
                </span>
              </p>
              <p className="text-amber-400 text-sm md:text-base font-semibold" data-id="element-3171">
                Pago único · Descarga inmediata
              </p>
            </div>

            {/* Main CTA Button */}
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" target="_blank" rel="noopener noreferrer" className="group block w-full" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'InitiateCheckout', {
                value: 17,
                currency: 'USD'
              });
            }
          }} data-id="element-3172">
              <button className="relative w-full bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-[#0a0e1a] font-black text-base md:text-xl uppercase tracking-tight py-5 md:py-6 px-6 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-3173">
                <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-3174">
                  <MessageSquare className="w-5 h-5 md:w-6 md:h-6" data-id="element-3175" />
                  👉 LLEVARME LA VERSIÓN LITE POR $17
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-3176" />
              </button>
            </a>

            {/* Microcopy */}
            <div className="mt-5 flex items-center justify-center gap-x-4 gap-y-2 flex-wrap text-xs md:text-sm text-gray-400" data-id="element-3177">
              <span className="flex items-center gap-1.5" data-id="element-3178">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-3179" />
                Descarga inmediata
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3180">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-3181" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3182">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-3183" />
                Pago seguro
              </span>
            </div>

            {/* Downsell link — right under the CTA so users don't miss the next step */}
            <div className="text-center mt-4" data-id="element-3184">
              <Link to="/thank-you" className="text-white hover:text-gray-200 text-sm md:text-base underline underline-offset-4 transition-colors" data-id="element-3185">
                No gracias, solo quiero ir al webinar →
              </Link>
            </div>

            {/* Guarantee Block */}
            <div className="mt-7 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center gap-4" data-id="element-3186">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-500/10 rounded-full flex items-center justify-center border border-emerald-500/20 flex-shrink-0" data-id="element-3187">
                <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-emerald-400" data-id="element-3188" />
              </div>
              <div className="text-center md:text-left" data-id="element-3189">
                <h4 className="text-white font-bold text-base md:text-lg mb-1" data-id="element-3190">
                  Misma Garantía: 7 Días
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-3191">
                  100% reembolso si no te sirve. Sin preguntas, sin letra
                  pequeña.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Trust footer note */}
        <div className="text-center text-gray-600 text-xs md:text-sm pt-6" data-id="element-3192">
          <Clock className="w-4 h-4 inline mr-1.5 mb-0.5" data-id="element-3193" />
          Esta oferta no estará disponible después de salir de esta página.
        </div>
      </main>

      <Footer data-id="element-3194" />
    </div>;
}